import { Module } from "wrapper6";
import {debounce} from "../utils/_debounce";

var $ = jQuery;

export default class Tasks extends Module {

	ready(app) {

        this.LOADER = $('#loader-overlay');
        this.DESTINATION = $('.mtt-tasks__cards');
        this.POST_TYPE = $('.mtt-tasks').attr('data-type');        

        this.FILTER_BTN = $('.mtt-tasks__term-wrapper--title-wrapper');
        this.FILTER_TERMS = document.querySelectorAll('.mtt-tasks__input');
        this.SMALL_FILTER_WRAPPER = document.querySelector('.mtt-tasks__active-filters--filters-wrapper');
        this.SEARCH_INPUT_BTN = $('.mtt-tasks__search-button.search-button');
        this.SEARCH_INPUT = $('#task-search');
        this.PAGINATION = '#tasks-pagination li a';
        this.PAGINATION_DEST = $('.mtt-tasks__pagination #tasks-pagination');

        // globals
        this.task_category = [];
        this.task_time = [];
        this.task_age = [];
        this.task_level = [];
        this.task_material = [];
        this.search_value = '';
        this.page_number = 0;
        
        this.addEventListeners();
    }

    addEventListeners() {
        this.addFilterSlide();
        this.filterTerms();
        this.resetTerms();
        this.addSmallTermsRemove();
        this.filterSearch();
    }

    filterSearch() {
        this.SEARCH_INPUT_BTN.on('click', () => {
            this.search_value = this.SEARCH_INPUT.val();
            this.page_number = 0;

            this.getTasks();
        });

        $(document).on('keypress',(e) => {
            if(e.which == 13) {
                if (this.SEARCH_INPUT.is(':focus')) {
                    this.search_value = this.SEARCH_INPUT.val();
                    this.page_number = 0;
        
                    this.getTasks();
                }
            }
        });

        // Click on pagination
		$(document).on('click', this.PAGINATION, (e) => {
                                    
			// Prevent default link behavior
			e.preventDefault();

			// Update page number
            this.page_number = $(e.target).attr('data-page');           

			// Run ajax request
			this.getTasks();

		});
    }

    addFilterSlide() {
        if (this.FILTER_BTN.length) {
            this.FILTER_BTN.on('click', (e) => {
                $(e.currentTarget).next().fadeToggle();
                $(e.currentTarget).find('.mtt-tasks__term-wrapper--dropdown').toggleClass('rotate');
            });
        }

        $('.mtt-tasks__terms-mobile').on('click', (e) => {
            $(e.currentTarget).siblings().toggleClass('show');
            $(e.currentTarget).find('.mtt-tasks__term-wrapper--dropdown').toggleClass('rotate');
        });

        $(window).on('resize', debounce(() => {
            $('.mtt-tasks__term-wrapper').removeAttr('style');
        },200));
    }

    filterTerms() {
        if (this.FILTER_TERMS.length) {
            for (let i = 0; i < this.FILTER_TERMS.length; i++) {
                const FILTER_TERM = this.FILTER_TERMS[i];
                
                FILTER_TERM.addEventListener('click', (e) => {

                    let input = FILTER_TERM.querySelector('input');
                    let term_tax = FILTER_TERM.getAttribute('data-tax');
                    const TERM_ID = FILTER_TERM.getAttribute('data-id'); 
                    
                    if(input.checked == false) {
                        input.checked = true; 
                    }
                    else {
                        if(input.checked == true) {
                            input.checked = false; 
                        }   
                    }
                    

                    this.addTermToCorrectArray(FILTER_TERM, term_tax, TERM_ID);
                    this.addTermToSmallFilters(FILTER_TERM, term_tax, TERM_ID);

                    this.page_number = 0;

                    this.getTasks();

                });
            }            
        }        
    }

    addTermToCorrectArray(element, tax, id) { 
        
        switch (tax) {
            case this.POST_TYPE + '-task-category':
                tax = this.task_category;
                break;
            case this.POST_TYPE + '-task-time':
                tax = this.task_time;
                break;
            case this.POST_TYPE + '-task-age':
                tax = this.task_age;
                break;
            case this.POST_TYPE + '-task-level':
                tax = this.task_level;
                break;
            case this.POST_TYPE + '-task-material':
                tax = this.task_material;
                break;
            default:
                break;
        }    

        if (element.querySelector('input').checked) {
            if (tax.indexOf(id) === -1) {
                tax.push(id);
            }
        } else {
            if (tax.indexOf(id) !== -1) {
                const INDEX = tax.indexOf(id);
                tax.splice(INDEX, 1);
            }
        }
    }

    addTermToSmallFilters(element, tax, id) {

        if (!this.SMALL_FILTER_WRAPPER.querySelector('[data-id="'+id+'"]')) {
            
            let small_term = document.createElement('div');            
            let small_term_title = element.querySelector('.title').innerHTML;

            let small_term_remove = document.createElement('div');
            small_term_remove.classList.add('close');
    
            small_term.classList.add('mtt-tasks__active-filters--filter');
            small_term.innerHTML = small_term_title;
            small_term.setAttribute('data-id', id);
            small_term.setAttribute('data-tax', tax);
            small_term.appendChild(small_term_remove);
    
            this.SMALL_FILTER_WRAPPER.appendChild(small_term);            
    
        } else {            
            this.SMALL_FILTER_WRAPPER.querySelector('[data-id="'+id+'"]').remove();
        }

    }

    resetTerms() {
        const RESET_BTN = document.querySelector('.mtt-tasks__active-filters--reset');

        if (RESET_BTN) {
            RESET_BTN.addEventListener('click', () => {
                this.task_category = [];
                this.task_time = [];
                this.task_age = [];
                this.task_level = [];
                this.task_material = [];
    
                for (let i = 0; i < this.FILTER_TERMS.length; i++) {
                    const FILTER_TERM = this.FILTER_TERMS[i];
                    let input = FILTER_TERM.querySelector('input');
                    
                    input.checked = false;
                }
    
                this.SMALL_FILTER_WRAPPER.innerHTML = '';
    
                this.getTasks();
            }); 
        }       
    }

    addSmallTermsRemove() {
        $(document).on('click', '.mtt-tasks__active-filters--filter', (e) => {
            const TAX = e.target.getAttribute('data-tax');
            const ID = e.target.getAttribute('data-id');           

            document.querySelector('.mtt-tasks__input[data-id="'+ID+'"]').querySelector('input').checked = false;
            e.target.remove();

            this.addTermToCorrectArray(e.target, TAX, ID);

            this.getTasks();
        });
    }

    getTasks() {
        // Show loader
            this.LOADER.addClass('show');	
              
            // Animate to top
            $('html, body').animate({ 
                scrollTop: $('.mtt-tasks').offset().top - 50
            }, 500);

			// Set ajax data
			let data = {
				'action': 'filter_tasks',
                'task_category': this.task_category,
                'task_time': this.task_time,
                'task_age': this.task_age,
                'task_level': this.task_level,
                'task_material': this.task_material,
                'search_value': this.search_value,
				'page_number': this.page_number,
                'url': window.location.href,
                'post_type': this.POST_TYPE
            };
            
			// Ajax call
			jQuery.post(main_theme_objects.ajax_url, data, (response) => {	                            

				if (response != 0) {                                             
                                    
					// Post response
                    if (response.markup !== "") {
                        this.DESTINATION.html(response.markup);                                            
                    } else {
                        this.DESTINATION.html('<p class="no-posts">Der er desværre ingen indlæg der opnår disse kriterier</p>');
                    }

					// Pagination response
                    this.PAGINATION_DEST.html(response.pagination);
                    
					// Hide loader
					this.LOADER.removeClass('show');

				}
			});
    }
}